// Messages de réussite / échec, par langue puis par thème (ton trash et décalé,
// gardés courts ~28 car. pour tenir sur la largeur du canvas). L'humour est
// TRANSCRÉÉ, pas traduit littéralement. Repli sur l'anglais si une langue manque
// une liste. Les pools SHARED_* (hérités des styles retirés WarioWare + Ren &
// Stimpy) sont ajoutés à tous les thèmes.

import type { ThemeKey } from "./themes";
import type { Lang } from "./i18n";

// ---------------------------------------------------------------------------
// FRANÇAIS
// ---------------------------------------------------------------------------

const SHARED_SUCCESS_FR: string[] = [
  "WAAAH ! Magot gluant",
  "Micro-jeu, maxi pépite",
  "Crésus kiffe ta morve",
  "STAGE CLEAR, sale gosse",
  "Pile dans le timing, gros",
  "GORGEOUS ! Crotte d'or",
  "Combo parfait, dégueu",
  "1-UP de morve verte",
  "Boss du microjeu crado",
  "Record battu, fouineur",
  "Crésus empoche ta pépite",
  "Trop fort, sale mioche",
  "Pièce d'or… non, de morve",
  "SUPER ! Bien gratté",
  "Vitesse max, crotte max",
  "T'as le tempo, salopard",
  "Niveau bonus dégueu",
  "Diamant de naseau, WAH",
  "Frénésie du curage",
  "Pris sur le vif, gluant",
  "Coffre plein à la Crésus",
  "Réflexe de champion crado",
  "Pépite express, bravo",
  "Or pur en 3 secondes",
  "Mini-jeu, méga-morve",
  "Magnifaïque, eediot !",
  "Bien gluant, façon Ren",
  "Stimpy adore ce trésor",
  "Boulette de luxe, joy",
  "Gros plan sur ta pépite",
  "Happy happy, crado crado",
  "Une beauté répugnante",
  "Crésus approuve, dégueu",
  "Trésor de chien galeux",
  "Visqueux à souhait, oui",
  "Stimpy le chat en bave",
  "Crotte digne d'un héros",
  "Bravo, génie du crade",
  "Log de morve, ça glisse",
  "Toast de naseau poudré",
  "Décrottage bien malsain",
  "Pépite bien grasse, joy",
  "T'es un artiste du crade",
  "Chef-d'œuvre répugnant",
  "Ça pue, c'est parfait",
  "Hystérie du fouille-nez",
  "Sublime saloperie, eediot",
  "Gratté à l'os, mon grand",
  "Le naseau te dit merci",
  "Pure folie gluante",
];

const SHARED_FAIL_FR: string[] = [
  "TIME UP, manchot",
  "Raté ! Recommence vite",
  "Crésus se fout de toi",
  "Loupé, gros boudin",
  "GAME OVER du tarin",
  "TROP LENT, tocard",
  "MISSION FAILED, banane",
  "Crésus te pique ton score",
  "Zéro pièce, zéro morve",
  "Foiré le timing, naze",
  "Réflexe de limace",
  "TRY AGAIN, bouffon",
  "Pas assez vite, mou du doigt",
  "Raté en mode facile, lol",
  "Continue ? Pfff, nul",
  "Doigt trop lent, abruti",
  "BOO ! Le public te hue",
  "Loupé, retourne au tuto",
  "Microjeu, macro-échec",
  "T'as cligné des yeux, raté",
  "Crésus rigole de ta tronche",
  "Plus lent qu'un escargot",
  "Score perdu, sale gosse",
  "Rejoue, espèce de patate",
  "Même Crésus vise mieux",
  "You EEDIOT, raté !",
  "Même Stimpy vise mieux",
  "Pathétique, sale chat",
  "Loupé, espèce de pignouf",
  "Magnifaïquement nul",
  "Ren te traite d'abruti",
  "Doigt de chien galeux",
  "Happy happy, raté raté",
  "T'es viré, eediot !",
  "Crade ET nul, bravo",
  "Le naseau te crache dessus",
  "Puant, et raté en plus",
  "Cerveau de chihuahua",
  "Toast d'échec poudré",
  "À côté, sac à puces",
  "Visée de chat malade",
  "Tu fais honte à Stimpy",
  "Lamentable, espèce d'idiot",
  "Raté, museau bouché",
  "Encore loupé, le galeux",
  "Tu glisses à côté, naze",
  "Ren hurle : EEDIOT !",
  "Pauvre tâche poilue",
  "Pas digne du caniveau",
  "Foiré, vieux clebs",
];

const SUCCESS_FR: Partial<Record<ThemeKey, string[]>> = {
  pixel: [
    "+100 PTS de morve",
    "HIGH SCORE crado",
    "PERFECT ! Pixel d'or",
    "Loot légendaire vert",
    "Combo x8-bit",
    "CRITICAL HIT gluant",
    "ACHIEVEMENT : sale gosse",
    "Drop rare : pépite verte",
    "NEW RECORD, fouineur",
    "Level up du curage",
    "Boss vaincu, morve drop",
    "FLAWLESS, dégueu",
    "+1 vie, +1 crotte",
    "Score x2, salopard",
    "Loot épique au naseau",
    "Power-up bien gluant",
    "S-RANK du fouille-nez",
    "Pixel parfait, bravo",
    "Inventaire : 1 pépite",
    "Cheat code activé, crado",
    "GG, mineur du dimanche",
    "Bonus stage déverrouillé",
    "Frag de morve confirmé",
    "Speedrun du décrottage",
    "100% complété, dégueu",
    ...SHARED_SUCCESS_FR,
  ],
  simpsons: [
    "Hmmm… crotte (bave)",
    "Excellent, Smithers !",
    "D'oh ! Mais réussi",
    "Pépite à la Homer",
    "Duff est fière de toi",
    "Woohoo ! Or du naseau",
    "Mmmh, donut de morve",
    "Homer en redemande, miam",
    "Bart kiffe ta pépite",
    "Springfield t'acclame",
    "Mange ma crotte, Flanders",
    "Sacré filon, mon garçon",
    "Marge serait dégoûtée, top",
    "Plus brillant qu'un donut",
    "Krusty valide, dégueu",
    "Trésor de centrale",
    "Eat my shorts, sale gosse",
    "Homer applaudit, miam",
    "Or vert façon centrale",
    "Doré comme la peau locale",
    "Pépite digne de Moe's",
    "T'as gratté comme un roi",
    "Cromulent, ce décrottage",
    "Parfaitement embiggené",
    "Nelson : HA-ha ! Réussi",
    ...SHARED_SUCCESS_FR,
  ],
  doodle: [
    "10/10, sale fouineur",
    "Mieux qu'un cours de maths",
    "Chef-d'œuvre au Bic",
    "Le prof valide ta crotte",
    "Gribouille d'or",
    "Tableau d'honneur du crade",
    "Bonbon vert sous la table",
    "Mention très bien, dégueu",
    "Croquis de morve réussi",
    "Récré bien méritée, gros",
    "Pépite en marge du cahier",
    "Génie du fond de la classe",
    "Bic bleu, crotte verte",
    "Premier de la classe crade",
    "Bravo, racaille d'école",
    "Devoir rendu : 1 pépite",
    "Le surveillant t'admire",
    "Mieux qu'un dessin de prof",
    "Bulletin : excellent dégueu",
    "T'as séché le cours, bien vu",
    "Note maximale au naseau",
    "Griffonnage gluant, top",
    "Champion de la cantine",
    "Cahier plein de crottes d'or",
    "Diplômé du fouille-nez",
    ...SHARED_SUCCESS_FR,
  ],
  zombie: [
    "Cervelle… euh, morve !",
    "Pourriture premium",
    "Bien gratté, macchabée",
    "Or vert de l'outre-tombe",
    "Putréfaction de luxe",
    "Trésor de charnier, miam",
    "Pépite bien moisie",
    "Gratté jusqu'à l'os, bravo",
    "Délice de tombe fraîche",
    "Asticot doré, magnifique",
    "Le mort-vivant t'acclame",
    "Chair à pépite, dégueu",
    "Butin de fosse commune",
    "Morve de zombie collector",
    "Bien creusé, croque-mort",
    "Putain de pépite pourrie",
    "Gangrène en or, top",
    "Festin du caveau",
    "Doigt de mort, touche d'or",
    "Récolte d'apocalypse, gros",
    "Vert cadavre, jaune pépite",
    "Brut de cimetière",
    "Tu pilles bien les tombes",
    "Suintement précieux",
    "Roi des goules du naseau",
    ...SHARED_SUCCESS_FR,
  ],
};

const FAIL_FR: Partial<Record<ThemeKey, string[]>> = {
  pixel: [
    "GAME OVER, noob",
    "MISS ! Insère une crotte",
    "404 : narine introuvable",
    "Lag du doigt, raté",
    "WASTED, sale tache",
    "Tu rage quit ou quoi ?",
    "Hitbox ratée, abruti",
    "Zéro XP, gros nul",
    "Doigt en mode lag",
    "RESPAWN, et vise mieux",
    "Skill issue, l'ami",
    "Crash de ta visée",
    "Loupé, console éteinte",
    "Combo brisé, banane",
    "0 PTS, retourne au menu",
    "Bot niveau facile, raté",
    "Ping 999, doigt à la rue",
    "Insert coin, gros naze",
    "Échec critique pixelisé",
    "Tuto pas fini, on dirait",
    "T'as visé un autre écran ?",
    "Manette débranchée, lol",
    "Hardcore raté, casual",
    "Bug : narine.exe absente",
    "Reset, doigt de bois",
    ...SHARED_FAIL_FR,
  ],
  simpsons: [
    "D'OH ! Raté, andouille",
    "Ay caramba, à côté !",
    "Mange ma morve, raté",
    "Multiplié par zéro, naze",
    "Eat my shorts… et rate",
    "Homer te traite de gnou",
    "Stupid sexy échec",
    "Bart se moque de toi",
    "Nelson : HA-ha ! Raté",
    "Loupé, espèce de Flanders",
    "Pire que Ralph, bravo",
    "Worst miss ever",
    "Skinner te colle, cancre",
    "À côté, gros Homer",
    "Donut zéro pour toi",
    "Moe te jette dehors",
    "D'oh ! Doigt mou, raté",
    "Springfield te hue",
    "Tu pues, dit Comic Book Guy",
    "Échec peu cromulent",
    "Krusty rigole de toi",
    "Centrale en alerte : raté",
    "Manchot de Springfield",
    "Même Ralph vise mieux",
    "Foiré, gros bêta",
    ...SHARED_FAIL_FR,
  ],
  doodle: [
    "Zéro pointé, cancre",
    "Deux heures de colle",
    "Hors-sujet, le manche",
    "Au fond de la classe, raté",
    "Le prof soupire, naze",
    "Copie blanche, bouffon",
    "Convoqué chez le proviseur",
    "Redoublant du curage",
    "Mot dans le carnet, raté",
    "Bonnet d'âne, andouille",
    "T'as gribouillé à côté",
    "Recopie 100 fois : je vise",
    "Exclu du cours, sale gosse",
    "Note : 0/20, nul",
    "Le surveillant te chope",
    "Devoir non rendu, raté",
    "Cancre du dernier rang",
    "Pris en flagrant délit, naze",
    "Bic à sec, doigt à sec",
    "Retenue le samedi, bravo",
    "La maternelle vise mieux",
    "Effacé à la gomme, ton score",
    "Colle générale, manchot",
    "Renvoyé pour visée nulle",
    "T'as raté, petit branleur",
    ...SHARED_FAIL_FR,
  ],
  zombie: [
    "Raté, sac à asticots",
    "Même un mort vise mieux",
    "À côté, viande froide",
    "Tes doigts tombent, raté ?",
    "Cervelle absente, on dirait",
    "Loupé, vieux cadavre",
    "Putréfié du cerveau, naze",
    "Manchot d'outre-tombe",
    "T'es déjà mort, et nul",
    "Le zombie se marre, raté",
    "Visée de macchabée bourré",
    "Gangrène jusqu'au doigt",
    "Raté, tas de pourriture",
    "Même la goule vise mieux",
    "À côté, charogne ambulante",
    "Doigt décomposé, forcément",
    "Loupé, vieux croûton",
    "Cimetière de ta dignité",
    "Asticot dans le cerveau ?",
    "Foiré, sac à viande",
    "Tu pues la mort, raté",
    "Hante ailleurs, raté",
    "Cadavre maladroit",
    "Pourri jusqu'aux ongles",
    "Game over… t'es déjà mort",
    ...SHARED_FAIL_FR,
  ],
};

// ---------------------------------------------------------------------------
// ENGLISH (transcréation, pas traduction littérale)
// ---------------------------------------------------------------------------

const SHARED_SUCCESS_EN: string[] = [
  "WAAAH! Slimy jackpot",
  "Mini-game, mega-nugget",
  "Crésus loves your snot",
  "STAGE CLEAR, you brat",
  "Nailed the timing, pal",
  "GORGEOUS! Golden booger",
  "Perfect combo, gross",
  "1-UP! Green and gooey",
  "Boss of the filthy dig",
  "Record smashed, digger",
  "Crésus grabs your nugget",
  "Too good, you brat",
  "A coin… no, a booger",
  "SUPER! Well scraped",
  "Max speed, max snot",
  "You got the tempo, punk",
  "Filthy bonus level",
  "Nostril diamond, WAH",
  "Digging frenzy",
  "Caught it live, gooey",
  "Chest full, Crésus-style",
  "Champion reflexes, gross",
  "Express nugget, bravo",
  "Pure gold in 3 seconds",
  "Mini-game, mega-booger",
  "Magnificent, eediot!",
  "Slimy, real Ren-style",
  "Stimpy loves this loot",
  "Deluxe booger, joy",
  "Close-up on your nugget",
  "Happy happy, gross gross",
  "A repulsive beauty",
  "Crésus approves, gross",
  "Mangy-dog treasure",
  "Gooey to the max, yes",
  "Stimpy the cat drools",
  "A booger fit for a hero",
  "Bravo, filth genius",
  "Snot log, it slides",
  "Powdered nose toast",
  "Gloriously sick dig",
  "Fat juicy nugget, joy",
  "You're a filth artist",
  "Repulsive masterpiece",
  "It stinks, it's perfect",
  "Booger-dig hysteria",
  "Sublime filth, eediot",
  "Scraped to the bone, kid",
  "The nostril thanks you",
  "Pure gooey madness",
];

const SHARED_FAIL_EN: string[] = [
  "TIME UP, klutz",
  "Missed! Be quicker",
  "Crésus laughs at you",
  "Whiffed it, fat finger",
  "GAME OVER, schnoz",
  "TOO SLOW, chump",
  "MISSION FAILED, dummy",
  "Crésus steals your score",
  "Zero coins, zero snot",
  "Blew the timing, loser",
  "Slug reflexes",
  "TRY AGAIN, buffoon",
  "Too slow, limp finger",
  "Missed on easy, lol",
  "Continue? Pfft, lame",
  "Finger too slow, idiot",
  "BOO! The crowd jeers",
  "Missed, back to tutorial",
  "Mini-game, mega-fail",
  "You blinked, missed",
  "Crésus mocks your mug",
  "Slower than a snail",
  "Score lost, you brat",
  "Replay, you potato",
  "Even Crésus aims better",
  "You EEDIOT, missed!",
  "Even Stimpy aims better",
  "Pathetic, filthy cat",
  "Missed, you pinhead",
  "Magnificently lame",
  "Crésus calls you a fool",
  "Mangy-dog finger",
  "Happy happy, fail fail",
  "You're fired, eediot!",
  "Filthy AND lame, bravo",
  "The nostril spits on you",
  "Stinky, and missed too",
  "Chihuahua brain",
  "Powdered fail toast",
  "Off-target, flea bag",
  "Sick-cat aim",
  "You shame Stimpy",
  "Hopeless, you idiot",
  "Missed, clogged snout",
  "Missed again, mutt",
  "Slid right off, lame",
  "Ren screams: EEDIOT!",
  "Poor furry loser",
  "Not even gutter-worthy",
  "Botched it, old mutt",
];

const SUCCESS_EN: Partial<Record<ThemeKey, string[]>> = {
  pixel: [
    "+100 PTS of snot",
    "HIGH SCORE, gross",
    "PERFECT! Pixel gold",
    "Legendary green loot",
    "Combo x8-bit",
    "CRITICAL HIT, gooey",
    "Achievement: snot lord",
    "Rare drop: green nugget",
    "NEW RECORD, digger",
    "Level up your dig",
    "Boss down, snot drops",
    "FLAWLESS, gross",
    "+1 life, +1 booger",
    "Score x2, punk",
    "Epic nostril loot",
    "Gooey power-up",
    "S-RANK nose-digger",
    "Pixel-perfect, bravo",
    "Inventory: 1 nugget",
    "Cheat code on, gross",
    "GG, weekend miner",
    "Bonus stage unlocked",
    "Snot frag confirmed",
    "Speedrun the dig",
    "100% complete, gross",
    ...SHARED_SUCCESS_EN,
  ],
  simpsons: [
    "Mmm… booger (drool)",
    "Excellent, Smithers!",
    "D'oh! But you nailed it",
    "A nugget Homer-style",
    "Duff is proud of you",
    "Woohoo! Nostril gold",
    "Mmmh, snot donut",
    "Okily-dokily, gross!",
    "Bart loves your nugget",
    "Springfield cheers you",
    "Eat my booger, Flanders",
    "Sweet vein, my boy",
    "Marge would gag, sweet",
    "Shinier than a donut",
    "Krusty approves, gross",
    "Power-plant treasure",
    "Eat my shorts, you brat",
    "Homer applauds, yum",
    "Green gold, plant-style",
    "Yellow as the locals",
    "A nugget worthy of Moe's",
    "You dug like a king",
    "Cromulent digging",
    "Perfectly embiggened",
    "Nelson: HA-ha! Nailed it",
    ...SHARED_SUCCESS_EN,
  ],
  doodle: [
    "10/10, filthy digger",
    "Better than math class",
    "Masterpiece in Bic pen",
    "Teacher okays your snot",
    "Doodle of gold",
    "Honor roll of filth",
    "Green candy under desk",
    "Straight A's, gross",
    "Snot sketch nailed it",
    "Well-earned recess, kid",
    "Nugget in the margin",
    "Back-row genius",
    "Blue pen, green booger",
    "Top of the filthy class",
    "Bravo, school menace",
    "Homework: 1 nugget",
    "Hall monitor admires it",
    "Better than teacher's art",
    "Report card: gross A+",
    "Skipped class, well done",
    "Gold star for digging",
    "Gooey scribble, ace",
    "Cafeteria champion",
    "Notebook full of gold",
    "Nose-digging graduate",
    ...SHARED_SUCCESS_EN,
  ],
  zombie: [
    "Brains… er, snot!",
    "Premium rot",
    "Well scraped, stiff",
    "Green gold from the grave",
    "Deluxe putrefaction",
    "Graveyard treasure, yum",
    "Nicely moldy nugget",
    "Scraped to the bone, yes",
    "Fresh-grave delicacy",
    "Golden maggot, gorgeous",
    "The undead cheer you",
    "Flesh nugget, gross",
    "Mass-grave loot",
    "Zombie snot, collector",
    "Well dug, gravedigger",
    "Damn fine rotten nugget",
    "Gangrene gold, sweet",
    "Feast of the crypt",
    "Dead finger, gold touch",
    "Apocalypse harvest, kid",
    "Corpse-green, gold snot",
    "Raw from the cemetery",
    "You loot graves well",
    "Precious ooze",
    "King of nostril ghouls",
    ...SHARED_SUCCESS_EN,
  ],
};

const FAIL_EN: Partial<Record<ThemeKey, string[]>> = {
  pixel: [
    "GAME OVER, noob",
    "MISS! Insert a booger",
    "404: nostril not found",
    "Finger lag, missed",
    "WASTED, dummy",
    "Rage quitting already?",
    "Hitbox missed, idiot",
    "Zero XP, big dummy",
    "Finger on lag mode",
    "RESPAWN, aim better",
    "Skill issue, buddy",
    "Your aim just crashed",
    "Missed, console off",
    "Combo broken, dummy",
    "0 PTS, back to menu",
    "Easy-mode bot, missed",
    "Ping 999, sloppy finger",
    "Insert coin, scrub",
    "Critical fail, pixelated",
    "Didn't finish the tutorial",
    "Aimed at another screen?",
    "Controller unplugged, lol",
    "Hardcore missed, casual",
    "Bug: nostril.exe missing",
    "Reset, wooden finger",
    ...SHARED_FAIL_EN,
  ],
  simpsons: [
    "D'OH! Missed, dummy",
    "Ay caramba, off-target!",
    "Eat my snot, missed",
    "Multiplied by zero, lame",
    "Eat my shorts… and miss",
    "Stupid, says Homer",
    "Stupid sexy failure",
    "Bart mocks you",
    "Nelson: HA-ha! Missed",
    "Missed, you Flanders",
    "Worse than Ralph, bravo",
    "Worst miss ever",
    "Skinner: detention!",
    "Off-target, big Homer",
    "Zero donuts for you",
    "Moe throws you out",
    "D'oh! Butterfingers",
    "Springfield jeers you",
    "Comic Guy: worst miss",
    "An uncromulent fail",
    "Krusty laughs at you",
    "Plant on alert: missed",
    "Klutz of Springfield",
    "Even Ralph aims better",
    "Botched it, big dummy",
    ...SHARED_FAIL_EN,
  ],
  doodle: [
    "Zero marks, dunce",
    "Two-hour detention",
    "Off-topic, klutz",
    "Back of class, missed",
    "Teacher sighs, lame",
    "Blank page, buffoon",
    "Sent to the principal",
    "Held back a grade",
    "Note in your planner",
    "Dunce cap, dummy",
    "You scribbled off-target",
    "Write 100x: I will aim",
    "Kicked out of class, brat",
    "Grade: 0/20, lame",
    "Hall monitor nabs you",
    "Homework not turned in",
    "Dunce of the back row",
    "Caught red-handed, lame",
    "Dry pen, dry finger",
    "Saturday detention, bravo",
    "Kindergarten aims better",
    "Your score, erased",
    "Whole-class detention",
    "Expelled for bad aim",
    "You missed, little brat",
    ...SHARED_FAIL_EN,
  ],
  zombie: [
    "Missed, bag of maggots",
    "Even a corpse aims better",
    "Off-target, cold meat",
    "Fingers fell off, missed?",
    "No brain, apparently",
    "Missed, old cadaver",
    "Rotten-brained, lame",
    "Klutz from the grave",
    "Already dead, and lame",
    "The zombie laughs, missed",
    "Drunk-corpse aim",
    "Gangrene to the finger",
    "Missed, pile of rot",
    "Even the ghoul aims better",
    "Off-target, carrion",
    "Decomposed finger, duh",
    "Missed, dusty corpse",
    "Cemetery of your dignity",
    "Maggot in your brain?",
    "Botched it, meat sack",
    "You reek of death, missed",
    "Haunt elsewhere, missed",
    "Clumsy cadaver",
    "Rotten to the fingertips",
    "Game over… you're dead",
    ...SHARED_FAIL_EN,
  ],
};

// ---------------------------------------------------------------------------
// РУССКИЙ (транскреация с культурной адаптацией : школьные оценки по 5-балльной
// системе, геймерский слэнг, мат в меру). Pas de traduction littérale.
// ---------------------------------------------------------------------------

const SHARED_SUCCESS_RU: string[] = [
  "ВАААХ! Слизкий куш",
  "Микроигра, макрокозявка",
  "Крёз тащится от козявки",
  "STAGE CLEAR, сопляк",
  "Точно в тайминг, бро",
  "ШИКАРНО! Козявка-голд",
  "Идеальное комбо, фу",
  "1-UP зелёной соплёй",
  "Босс грязной копки",
  "Рекорд побит, копатель",
  "Крёз стырил твой кусок",
  "Силён, сопляк",
  "Монета… нет, козявка",
  "СУПЕР! Чисто выскреб",
  "Макс скорость, макс сопли",
  "Поймал ритм, гадёныш",
  "Бонус-уровень, фу",
  "Алмаз из ноздри, ВАХ",
  "Бешеная копка",
  "Поймал вживую, слизь",
  "Сундук набит, как у Крёза",
  "Чемпионский рефлекс, фу",
  "Экспресс-самородок!",
  "Чистое золото за 3 сек",
  "Микроигра, мегакозявка",
  "Великолепно, ИДИОТ!",
  "Слизко, прям как Рен",
  "Стимпи-кот в восторге",
  "Люкс-козявка, да",
  "Крупный план козявки",
  "Хэппи-хэппи, фу-фу",
  "Отвратительно прекрасно",
  "Крёз одобряет, фу",
  "Клад шелудивого пса",
  "Слизко по максимуму, да",
  "Стимпи-кот пускает слюни",
  "Козявка, достойная героя",
  "Браво, гений грязи",
  "Бревно соплей скользит",
  "Козявка с кулак, фу",
  "Мерзко, и это прекрасно",
  "Жирная сочная козявка",
  "Ты художник по грязи",
  "Мерзкий шедевр",
  "Воняет — значит, идеально",
  "Истерия носокопания",
  "Шикарная грязь, ИДИОТ",
  "Выскреб до кости, парень",
  "Ноздря говорит спасибо",
  "Чистое слизкое безумие",
];

const SHARED_FAIL_RU: string[] = [
  "ВРЕМЯ ВЫШЛО, криворук",
  "Мимо! Давай быстрее",
  "Крёз ржёт над тобой",
  "Промазал, толстопал",
  "GAME OVER для носа",
  "СЛИШКОМ МЕДЛЕННО, лох",
  "MISSION FAILED, балбес",
  "Крёз спёр твои очки",
  "Ноль монет, ноль соплей",
  "Запорол тайминг, лузер",
  "Рефлексы улитки",
  "TRY AGAIN, клоун",
  "Медленно, вялый палец",
  "Промах на лёгком, лол",
  "Продолжить? Пффф, отстой",
  "Палец тормозит, тупица",
  "БУ! Толпа освистывает",
  "Мимо, назад в туториал",
  "Микроигра, макропровал",
  "Моргнул — промахнулся",
  "Крёз ржёт над рожей",
  "Медленнее улитки",
  "Очки потеряны, сопляк",
  "Переиграй, картоха",
  "Даже Крёз целится лучше",
  "Ты ИДИОТ, промах!",
  "Даже Стимпи целится лучше",
  "Жалко, грязный кот",
  "Мимо, тупоголовый",
  "Великолепно бездарно",
  "Крёз зовёт тебя дураком",
  "Палец шелудивого пса",
  "Хэппи-хэппи, мимо-мимо",
  "Ты уволен, ИДИОТ!",
  "Грязно И бездарно, браво",
  "Ноздря плюёт в тебя",
  "Вонючка, да ещё и мимо",
  "Мозг чихуахуа",
  "Тост провала с пудрой",
  "Мимо, блохастый",
  "Прицел больного кота",
  "Позоришь Стимпи",
  "Безнадёжно, идиот",
  "Мимо, нос забит",
  "Снова мимо, дворняга",
  "Соскользнул, лузер",
  "Рен орёт: ИДИОТ!",
  "Жалкий волосатый лох",
  "Недостоин даже канавы",
  "Запорол, старый пёс",
];

const SUCCESS_RU: Partial<Record<ThemeKey, string[]>> = {
  pixel: [
    "+100 ОЧКОВ соплей",
    "ХАЙ-СКОР, мерзость",
    "PERFECT! Пиксель-голд",
    "Легендарный зелёный лут",
    "Комбо x8-бит",
    "КРИТ! Слизкий удар",
    "АЧИВКА: сопляк",
    "Редкий дроп: козявка",
    "НОВЫЙ РЕКОРД, копатель",
    "Прокачал копание",
    "Босс пал, дроп соплей",
    "FLAWLESS, мерзота",
    "+1 жизнь, +1 козявка",
    "Очки x2, гадёныш",
    "Эпик-лут из ноздри",
    "Слизкий пауэр-ап",
    "S-RANK носокопателя",
    "Пиксель-перфект, браво",
    "Инвентарь: 1 самородок",
    "Чит активирован, фу",
    "GG, копатель-любитель",
    "Бонус-уровень открыт",
    "Фраг соплёй подтверждён",
    "Спидран копания",
    "100% пройдено, фу",
    ...SHARED_SUCCESS_RU,
  ],
  simpsons: [
    "Ммм… козявка (слюни)",
    "Отлично, Смитерс!",
    "Д'оу! Но ты попал",
    "Самородок по-Гомеровски",
    "Дафф тобой гордится",
    "Вуху! Золото ноздри",
    "Ммм, сопля-пончик",
    "Окидоки, мерзость!",
    "Барт в восторге",
    "Спрингфилд тебя славит",
    "Ешь козявку, Фландерс",
    "Знатная жила, сынок",
    "Мардж бы стошнило, класс",
    "Блестит ярче пончика",
    "Красти одобряет, фу",
    "Сокровище АЭС",
    "Ешь мои шорты, сопляк",
    "Гомер аплодирует, ням",
    "Зелёное золото с АЭС",
    "Жёлтый как местные",
    "Самородок для бара Мо",
    "Копал как король",
    "Кромулентное копание",
    "Достойно Спрингфилда",
    "Нельсон: ХА-ха! Попал",
    ...SHARED_SUCCESS_RU,
  ],
  doodle: [
    "5/5, грязный копатель",
    "Лучше урока математики",
    "Шедевр шариковой ручкой",
    "Училка одобряет козявку",
    "Золотой рисунок",
    "Доска почёта грязи",
    "Зелёная конфета под партой",
    "Сплошные пятёрки, фу",
    "Набросок соплёй — топ",
    "Заслуженная переменка",
    "Самородок на полях",
    "Гений с последней парты",
    "Синяя ручка, зелёная сопля",
    "Лучший в грязном классе",
    "Браво, школьная гроза",
    "Домашка: 1 самородок",
    "Дежурный восхищён",
    "Лучше рисунка училки",
    "Дневник: мерзкая пятёрка",
    "Прогулял урок — красава",
    "Золотая звезда за копку",
    "Слизкие каракули — топ",
    "Чемпион столовки",
    "Тетрадь полна золота",
    "Дипломированный носокоп",
    ...SHARED_SUCCESS_RU,
  ],
  zombie: [
    "Мозги… то есть сопли!",
    "Премиум-гниль",
    "Чисто выскреб, жмурик",
    "Зелёное золото из могилы",
    "Люкс-разложение",
    "Кладбищенский клад, ням",
    "Знатно заплесневела",
    "Выскреб до кости, да",
    "Деликатес из могилы",
    "Золотой опарыш, прелесть",
    "Нежить тебя славит",
    "Кусок плоти, фу",
    "Лут из братской могилы",
    "Зомби-сопля, коллекция",
    "Отлично вырыл, могильщик",
    "Чёртов гнилой самородок",
    "Гангрена-голд, класс",
    "Пир из склепа",
    "Палец мертвеца, золото",
    "Урожай апокалипсиса",
    "Трупно-зелёный кусок",
    "Сырьё с кладбища",
    "Знатно грабишь могилы",
    "Драгоценная слизь",
    "Король носовых упырей",
    ...SHARED_SUCCESS_RU,
  ],
};

const FAIL_RU: Partial<Record<ThemeKey, string[]>> = {
  pixel: [
    "GAME OVER, нуб",
    "MISS! Вставь козявку",
    "404: ноздря не найдена",
    "Лаг пальца, мимо",
    "WASTED, тупица",
    "Уже рейдж-квит?",
    "Хитбокс мимо, идиот",
    "Ноль опыта, балбес",
    "Палец в режиме лага",
    "RESPAWN, целься лучше",
    "Скилл-ишью, дружок",
    "Прицел крашнулся",
    "Мимо, консоль выкл",
    "Комбо сломано, балда",
    "0 ОЧКОВ, назад в меню",
    "Бот на лёгком, и мимо",
    "Пинг 999, кривой палец",
    "Вставь монету, лошок",
    "Крит-провал в пикселях",
    "Туториал не пройден",
    "Целился в другой экран?",
    "Джойстик отключён, лол",
    "Хардкор мимо, казуал",
    "Баг: ноздря.exe нет",
    "Ресет, деревянный палец",
    ...SHARED_FAIL_RU,
  ],
  simpsons: [
    "Д'оу! Мимо, балда",
    "Ай, карамба, мимо!",
    "Ешь мою соплю, мимо",
    "Умножь на ноль, отстой",
    "Ешь мои шорты… и мимо",
    "Тупой, говорит Гомер",
    "Тупой сексуальный провал",
    "Барт смеётся над тобой",
    "Нельсон: ХА-ха! Мимо",
    "Мимо, ну ты и Фландерс",
    "Хуже Ральфа, браво",
    "Худший промах в мире",
    "Скиннер: после уроков!",
    "Мимо, толстый Гомер",
    "Ноль пончиков тебе",
    "Мо вышвыривает тебя",
    "Д'оу! Растяпа",
    "Спрингфилд освистывает",
    "Ты воняешь, — Комик-гай",
    "Некромулентный провал",
    "Красти ржёт над тобой",
    "АЭС в тревоге: мимо",
    "Растяпа из Спрингфилда",
    "Даже Ральф целится лучше",
    "Запорол, балбесина",
    ...SHARED_FAIL_RU,
  ],
  doodle: [
    "Двойка, балбес",
    "Два часа после уроков",
    "Не по теме, криворук",
    "На задней парте, мимо",
    "Училка вздыхает, отстой",
    "Чистый лист, клоун",
    "К директору!",
    "Оставлен на второй год",
    "Запись в дневнике, мимо",
    "В угол, балда",
    "Накалякал мимо",
    "100 раз: я буду целиться",
    "Выгнан с урока, сопляк",
    "Оценка: 2/5, отстой",
    "Дежурный тебя поймал",
    "Домашка не сдана, мимо",
    "Двоечник с галёрки",
    "Пойман с поличным, лажа",
    "Ручка сухая, палец сухой",
    "Оставлен после уроков",
    "Детсад целится лучше",
    "Очки стёрты ластиком",
    "Весь класс наказан",
    "Отчислен за кривой прицел",
    "Промазал, мелкий гадёныш",
    ...SHARED_FAIL_RU,
  ],
  zombie: [
    "Мимо, мешок опарышей",
    "Даже труп целится лучше",
    "Мимо, холодное мясо",
    "Пальцы отвалились, мимо?",
    "Мозга нет, видимо",
    "Мимо, старый труп",
    "Сгнивший мозг, отстой",
    "Криворук из могилы",
    "Уже мёртв и бездарен",
    "Зомби ржёт, промах",
    "Прицел пьяного жмурика",
    "Гангрена до пальца",
    "Мимо, куча гнили",
    "Даже упырь целится лучше",
    "Мимо, падаль",
    "Разложившийся палец, ясно",
    "Мимо, старый сухарь",
    "Кладбище твоей гордости",
    "Опарыш в мозгу?",
    "Запорол, мешок мяса",
    "Воняешь смертью, мимо",
    "Иди пугай кого-то ещё",
    "Неуклюжий труп",
    "Сгнил до кончиков пальцев",
    "Game over… ты уже мёртв",
    ...SHARED_FAIL_RU,
  ],
};

// ---------------------------------------------------------------------------
// ESPAÑOL (transcreación con adaptación cultural : doblaje latino de los Simpson,
// jerga gamer, registro gamberro). Pas de traduction littérale. Creso = Crésus.
// ---------------------------------------------------------------------------

const SHARED_SUCCESS_ES: string[] = [
  "¡WAAAH! Botín viscoso",
  "Microjuego, megamoco",
  "Creso ama tu moco",
  "STAGE CLEAR, mocoso",
  "Justo a tiempo, crack",
  "¡PRECIOSO! Moco de oro",
  "Combo perfecto, asco",
  "1-UP de moco verde",
  "Jefe del cavado cochino",
  "Récord roto, escarbador",
  "Creso te quita la pepita",
  "Muy bueno, mocoso",
  "Moneda… no, un moco",
  "¡SÚPER! Bien rascado",
  "Máxima velocidad y moco",
  "Agarraste el ritmo, pillo",
  "Nivel bonus, qué asco",
  "Diamante de nariz, WAH",
  "Frenesí escarbador",
  "Cazado al vuelo, viscoso",
  "Cofre lleno, cual Creso",
  "Reflejo de campeón, asco",
  "¡Pepita exprés, bravo!",
  "Oro puro en 3 segundos",
  "Mini juego, mega pepita",
  "¡Magnífico, idiota!",
  "Viscoso, estilo Ren",
  "A Stimpy le encanta",
  "Moco de lujo, ¡yupi!",
  "Primer plano del moco",
  "Feliz feliz, asco asco",
  "Una belleza repugnante",
  "Creso lo aprueba, asco",
  "Tesoro de perro sarnoso",
  "Viscoso a tope, sí",
  "Stimpy el gato babea",
  "Moco digno de un héroe",
  "Bravo, genio del asco",
  "Tronco de moco resbala",
  "Tostada nasal en polvo",
  "Asqueroso pero perfecto",
  "Gordo moco jugoso, yupi",
  "Eres un artista del asco",
  "Obra maestra repugnante",
  "Apesta, o sea, perfecto",
  "Histeria del hurganariz",
  "Sublime porquería, idiota",
  "Rascado hasta el hueso",
  "La nariz te da las gracias",
  "Pura locura viscosa",
];

const SHARED_FAIL_ES: string[] = [
  "TIEMPO FUERA, torpe",
  "¡Fallo! Más rápido",
  "Creso se ríe de ti",
  "Fallaste, dedo gordo",
  "GAME OVER de la nariz",
  "DEMASIADO LENTO, perdedor",
  "MISSION FAILED, menso",
  "Creso te roba los puntos",
  "Cero monedas, cero moco",
  "Tiempo mal, perdedor",
  "Reflejos de babosa",
  "TRY AGAIN, payaso",
  "Lento, dedo flojo",
  "Fallo en fácil, jajaja",
  "¿Seguir? Bah, inútil",
  "Dedo lento, tonto",
  "¡BUUU! El público abuchea",
  "Fallo, vuelve al tutorial",
  "Microjuego, macrofracaso",
  "Parpadeaste y fallaste",
  "Creso se ríe en tu cara",
  "Más lento que un caracol",
  "Puntos perdidos, mocoso",
  "Repite, cabeza de papa",
  "Hasta Creso apunta mejor",
  "¡Eres IDIOTA, fallo!",
  "Stimpy apunta mejor",
  "Patético, gato cochino",
  "Fallo, cabeza hueca",
  "Magníficamente inútil",
  "Creso te llama tonto",
  "Dedo de perro sarnoso",
  "Feliz feliz, fallo fallo",
  "¡Estás despedido, idiota!",
  "Cochino Y malo, bravo",
  "La nariz te escupe",
  "Apestoso y encima fallas",
  "Cerebro de chihuahua",
  "Tostada del fracaso",
  "Fuera, bicho pulgoso",
  "Puntería de gato enfermo",
  "Avergüenzas a Stimpy",
  "Sin remedio, idiota",
  "Fallo, nariz tapada",
  "Otra vez fallo, pulgoso",
  "Te resbalas, perdedor",
  "Ren grita: ¡IDIOTA!",
  "Pobre perdedor peludo",
  "Ni para la cuneta",
  "Fallaste, perro viejo",
];

const SUCCESS_ES: Partial<Record<ThemeKey, string[]>> = {
  pixel: [
    "+100 PTS de moco",
    "HIGH SCORE cochino",
    "¡PERFECT! Píxel de oro",
    "Loot legendario verde",
    "Combo x8-bits",
    "¡CRÍTICO! Viscoso",
    "LOGRO: mocoso",
    "Drop raro: pepita verde",
    "NUEVO RÉCORD, escarbador",
    "Sube de nivel cavando",
    "Jefe muerto, suelta moco",
    "FLAWLESS, qué asco",
    "+1 vida, +1 moco",
    "Puntos x2, golfo",
    "Loot épico de la nariz",
    "Power-up viscoso",
    "Rango S del hurganariz",
    "Pixel perfect, bravo",
    "Inventario: 1 pepita",
    "Truco activado, asco",
    "GG, minero de domingo",
    "Nivel bonus desbloqueado",
    "Frag de moco confirmado",
    "Speedrun del escarbado",
    "100% completado, asco",
    ...SHARED_SUCCESS_ES,
  ],
  simpsons: [
    "Mmm… moco (baba)",
    "¡Excelente, Smithers!",
    "¡D'oh! Pero acertaste",
    "Pepita estilo Homer",
    "Duff está orgullosa",
    "¡Wuju! Oro de nariz",
    "Mmm, dona de moco",
    "¡Mmm, tremenda pepita!",
    "A Bart le encanta",
    "Springfield te aclama",
    "Cómete mi moco, Flanders",
    "Buena veta, muchacho",
    "A Marge le daría asco",
    "Brilla más que una dona",
    "Krusty lo aprueba, asco",
    "Tesoro de la central",
    "¡Cómete mis calzones!",
    "Homer aplaude, ñam",
    "Oro verde de la central",
    "Amarillo como los de ahí",
    "Pepita digna de Moe",
    "Cavaste como un rey",
    "Cavado cromulento",
    "Perfectamente embiggenado",
    "Nelson: ¡JA-ja! Acertaste",
    ...SHARED_SUCCESS_ES,
  ],
  doodle: [
    "10/10, escarbador cochino",
    "Mejor que matemáticas",
    "Obra maestra a lapicero",
    "La profe aprueba tu moco",
    "Dibujo de oro",
    "Cuadro de honor del asco",
    "Caramelo verde, a escondidas",
    "Puro diez, qué asco",
    "Boceto de moco, ¡top!",
    "Recreo bien merecido",
    "Pepita en el margen",
    "Genio de la última fila",
    "Lapicero azul, moco verde",
    "El mejor de clase, cochino",
    "Bravo, terror de la escuela",
    "Tarea: 1 pepita",
    "El conserje te admira",
    "Mejor que el dibujo del profe",
    "Boletín: diez en asco",
    "Te saltaste clase, crack",
    "Nota máxima en la nariz",
    "Garabato viscoso, top",
    "Campeón del comedor",
    "Cuaderno lleno de oro",
    "Graduado en hurganariz",
    ...SHARED_SUCCESS_ES,
  ],
  zombie: [
    "Sesos… digo, ¡moco!",
    "Podredumbre premium",
    "Bien rascado, fiambre",
    "Oro verde de la tumba",
    "Putrefacción de lujo",
    "Tesoro de osario, ñam",
    "Pepita bien mohosa",
    "Rascado hasta el hueso",
    "Manjar de tumba fresca",
    "Gusano dorado, precioso",
    "Los muertos te aclaman",
    "Trozo de carne, asco",
    "Botín de fosa común",
    "Moco zombi, de colección",
    "Bien cavado, sepulturero",
    "Maldita pepita podrida",
    "Gangrena de oro, top",
    "Festín de la cripta",
    "Dedo muerto, toque de oro",
    "Cosecha apocalíptica",
    "Verde cadáver, oro moco",
    "Materia prima de tumba",
    "Saqueas tumbas genial",
    "Preciosa supuración",
    "Rey de los gules nasales",
    ...SHARED_SUCCESS_ES,
  ],
};

const FAIL_ES: Partial<Record<ThemeKey, string[]>> = {
  pixel: [
    "GAME OVER, novato",
    "¡MISS! Mete un moco",
    "404: nariz no encontrada",
    "Lag del dedo, fallo",
    "WASTED, tonto",
    "¿Ya haces rage quit?",
    "Hitbox fallida, idiota",
    "Cero XP, zoquete",
    "Dedo en modo lag",
    "RESPAWN, apunta mejor",
    "Skill issue, amigo",
    "Tu puntería crasheó",
    "Fallo, consola apagada",
    "Combo roto, menso",
    "0 PTS, vuelve al menú",
    "Bot en fácil, y fallas",
    "Ping 999, dedo torpe",
    "Mete moneda, perdedor",
    "Fallo crítico pixelado",
    "No acabaste el tutorial",
    "¿Apuntaste a otra pantalla?",
    "Control desconectado, jaja",
    "Hardcore fallido, casual",
    "Bug: nariz.exe no está",
    "Reset, dedo de palo",
    ...SHARED_FAIL_ES,
  ],
  simpsons: [
    "¡D'OH! Fallo, menso",
    "¡Ay, caramba, al lado!",
    "Cómete mi moco, fallo",
    "Multiplícate por cero",
    "Cómete mis calzones… y falla",
    "Homer te llama burro",
    "Estúpido y sexy fracaso",
    "Bart se ríe de ti",
    "Nelson: ¡JA-ja! Fallo",
    "Fallo, menudo Flanders",
    "Peor que Ralph, bravo",
    "El peor fallo del mundo",
    "Skinner: ¡castigado!",
    "Al lado, gordo Homer",
    "Cero donas para ti",
    "Moe te echa a la calle",
    "¡D'oh! Manos torpes",
    "Springfield te abuchea",
    "Apestas, dice el de cómics",
    "Fracaso poco cromulento",
    "Krusty se ríe de ti",
    "Central en alerta: fallo",
    "Torpe de Springfield",
    "Hasta Ralph apunta mejor",
    "Fallaste, zoquetón",
    ...SHARED_FAIL_ES,
  ],
  doodle: [
    "Puro cero, zoquete",
    "Dos horas de castigo",
    "Fuera de tema, torpe",
    "Al fondo de la clase, fallo",
    "La profe suspira, malo",
    "Hoja en blanco, payaso",
    "¡Al despacho del director!",
    "Repites curso por cavar",
    "Nota en la agenda, fallo",
    "Orejas de burro, menso",
    "Garabateaste al lado",
    "Copia 100 veces: apuntaré",
    "Expulsado de clase, mocoso",
    "Nota: 0/10, malo",
    "El conserje te atrapa",
    "Tarea sin entregar",
    "Zoquete de la última fila",
    "Atrapado in fraganti, malo",
    "Lapicero seco, dedo seco",
    "Castigo el sábado, bravo",
    "Hasta un nene apunta mejor",
    "Tus puntos, borrados",
    "Toda la clase castigada",
    "Expulsado por mala mira",
    "Fallaste, mocoso de mierda",
    ...SHARED_FAIL_ES,
  ],
  zombie: [
    "Fallo, saco de gusanos",
    "Un muerto apunta mejor",
    "Al lado, carne fría",
    "¿Se te caen los dedos?",
    "Sin cerebro, se nota",
    "Fallo, viejo cadáver",
    "Cerebro podrido, malo",
    "Torpe de ultratumba",
    "Ya muerto y encima malo",
    "El zombi se ríe, fallo",
    "Puntería de fiambre ebrio",
    "Gangrena hasta el dedo",
    "Fallo, montón de podre",
    "Un gul apunta mejor",
    "Al lado, carroña",
    "Dedo descompuesto, claro",
    "Fallo, viejo pellejo",
    "Cementerio de tu honor",
    "¿Gusano en el cerebro?",
    "Fallaste, saco de carne",
    "Apestas a muerte, fallo",
    "Vete a penar a otro lado",
    "Cadáver torpe",
    "Podrido hasta las uñas",
    "Game over… ya estás muerto",
    ...SHARED_FAIL_ES,
  ],
};

// ---------------------------------------------------------------------------
// PORTUGUÊS (BR) (transcriação com adaptação cultural : dublagem BR dos Simpsons,
// gíria gamer, escola brasileira, registro zoeira). Creso = Crésus.
// ---------------------------------------------------------------------------

const SHARED_SUCCESS_PT: string[] = [
  "WAAAH! Tesouro meleca",
  "Microjogo, megapepita",
  "Creso ama sua meleca",
  "STAGE CLEAR, pirralho",
  "Bem no tempo, parça",
  "LINDO! Meleca de ouro",
  "Combo perfeito, eca",
  "1-UP de ranho verde",
  "Chefe da cavada nojenta",
  "Recorde batido, cavador",
  "Creso rouba sua pepita",
  "Mandou bem, pirralho",
  "Moeda… não, meleca",
  "SUPER! Bem raspado",
  "Velocidade e ranho max",
  "Pegou o ritmo, moleque",
  "Fase bônus, que nojo",
  "Diamante de nariz, WAH",
  "Frenesi da cavada",
  "Pego ao vivo, meleca",
  "Baú cheio, tipo Creso",
  "Reflexo de campeão, eca",
  "Pepita expressa, bravo",
  "Ouro puro em 3 segundos",
  "Minijogo, megapepita",
  "Magnífico, idiota!",
  "Meleca, estilo Ren",
  "Stimpy ama esse tesouro",
  "Meleca de luxo, eba!",
  "Close na sua pepita",
  "Feliz feliz, eca eca",
  "Uma beleza repugnante",
  "Creso aprova, que nojo",
  "Tesouro de cão sarnento",
  "Meleca ao máximo, sim",
  "Stimpy, o gato, baba",
  "Meleca digna de herói",
  "Bravo, gênio da gosma",
  "Tronco de ranho desliza",
  "Torrada nasal em pó",
  "Nojento mas perfeito",
  "Meleca gorda e suculenta",
  "Você é artista da gosma",
  "Obra-prima repugnante",
  "Fede, ou seja, perfeito",
  "Histeria do cavanariz",
  "Sublime nojeira, idiota",
  "Raspado até o osso, moleque",
  "O nariz te agradece",
  "Pura loucura meleca",
];

const SHARED_FAIL_PT: string[] = [
  "TEMPO ESGOTADO, mão de pé",
  "Errou! Mais rápido",
  "Creso ri de você",
  "Errou, dedo gordo",
  "GAME OVER do nariz",
  "LENTO DEMAIS, banana",
  "MISSION FAILED, mané",
  "Creso rouba seus pontos",
  "Zero moeda, zero meleca",
  "Errou o tempo, perdedor",
  "Reflexo de lesma",
  "TRY AGAIN, palhaço",
  "Lento, dedo mole",
  "Errou no fácil, kkkk",
  "Continuar? Pff, fraco",
  "Dedo lento, tonto",
  "BUU! A galera vaia",
  "Errou, volta pro tutorial",
  "Microjogo, macrovexame",
  "Piscou e errou",
  "Creso ri da sua cara",
  "Mais lento que lesma",
  "Pontos perdidos, pirralho",
  "Joga de novo, batata",
  "Até Creso mira melhor",
  "Você é IDIOTA, errou!",
  "Até Stimpy mira melhor",
  "Patético, gato imundo",
  "Errou, cabeça oca",
  "Magnificamente inútil",
  "Creso te chama de burro",
  "Dedo de cão sarnento",
  "Feliz feliz, errou errou",
  "Tá demitido, idiota!",
  "Imundo E ruim, bravo",
  "O nariz cospe em você",
  "Fedido e ainda errou",
  "Cérebro de chihuahua",
  "Torrada do fracasso",
  "Errou, bicho pulguento",
  "Mira de gato doente",
  "Você envergonha o Stimpy",
  "Sem jeito, idiota",
  "Errou, nariz entupido",
  "Errou de novo, vira-lata",
  "Escorregou, perdedor",
  "Ren grita: IDIOTA!",
  "Pobre perdedor peludo",
  "Nem pra sarjeta serve",
  "Errou, cão velho",
];

const SUCCESS_PT: Partial<Record<ThemeKey, string[]>> = {
  pixel: [
    "+100 PTS de meleca",
    "HIGH SCORE nojento",
    "PERFECT! Pixel de ouro",
    "Loot lendário verde",
    "Combo x8-bits",
    "CRÍTICO! Gosmento",
    "CONQUISTA: pirralho",
    "Drop raro: pepita verde",
    "NOVO RECORDE, cavador",
    "Upou no cavar",
    "Chefe morto, dropa ranho",
    "FLAWLESS, que nojo",
    "+1 vida, +1 meleca",
    "Pontos x2, moleque",
    "Loot épico do nariz",
    "Power-up gosmento",
    "Rank S do cavanariz",
    "Pixel perfect, bravo",
    "Inventário: 1 pepita",
    "Cheat ativado, eca",
    "GG, mineiro de fds",
    "Fase bônus liberada",
    "Frag de meleca confirmado",
    "Speedrun da cavada",
    "100% completo, eca",
    ...SHARED_SUCCESS_PT,
  ],
  simpsons: [
    "Mmm… meleca (baba)",
    "Excelente, Smithers!",
    "Dou! Mas acertou",
    "Pepita estilo Homer",
    "Duff tem orgulho de você",
    "Eba! Ouro do nariz",
    "Mmm, rosquinha de meleca",
    "Mandou bem, seu Homer",
    "Bart ama sua pepita",
    "Springfield te aclama",
    "Coma minha meleca, Flanders",
    "Bela veia, garoto",
    "A Marge teria nojo",
    "Brilha mais que rosquinha",
    "Krusty aprova, que nojo",
    "Tesouro da usina",
    "Engula essa, pirralho",
    "Homer aplaude, nham",
    "Ouro verde da usina",
    "Amarelo como os locais",
    "Pepita digna do bar do Mo",
    "Cavou feito um rei",
    "Cavada cromulenta",
    "Perfeitamente engrandado",
    "Nelson: HÁ-há! Acertou",
    ...SHARED_SUCCESS_PT,
  ],
  doodle: [
    "10/10, cavador nojento",
    "Melhor que aula de mate",
    "Obra-prima de caneta",
    "Fessora aprova sua meleca",
    "Desenho de ouro",
    "Quadro de honra da gosma",
    "Bala verde embaixo da mesa",
    "Nota dez, que nojo",
    "Esboço de meleca, top",
    "Recreio bem merecido",
    "Pepita na margem",
    "Gênio da última fileira",
    "Caneta azul, meleca verde",
    "Melhor da turma nojenta",
    "Bravo, terror da escola",
    "Dever: 1 pepita",
    "O inspetor te admira",
    "Melhor que desenho da fessora",
    "Boletim: nojo nota dez",
    "Matou aula, mandou bem",
    "Nota máxima no nariz",
    "Rabisco gosmento, top",
    "Campeão da cantina",
    "Caderno cheio de ouro",
    "Formado em cavanariz",
    ...SHARED_SUCCESS_PT,
  ],
  zombie: [
    "Cérebro… digo, meleca!",
    "Podridão premium",
    "Bem raspado, defunto",
    "Ouro verde do além",
    "Putrefação de luxo",
    "Tesouro de vala, nham",
    "Pepita bem mofada",
    "Raspado até o osso",
    "Iguaria de cova fresca",
    "Larva dourada, linda",
    "Os mortos te aclamam",
    "Pedaço de carne, eca",
    "Butim de vala comum",
    "Meleca zumbi, de coleção",
    "Bem cavado, coveiro",
    "Maldita pepita podre",
    "Gangrena de ouro, top",
    "Banquete da cripta",
    "Dedo morto, toque de ouro",
    "Colheita do apocalipse",
    "Verde cadáver, ouro meleca",
    "Matéria-prima da cova",
    "Você saqueia covas bem",
    "Preciosa secreção",
    "Rei dos carniçais nasais",
    ...SHARED_SUCCESS_PT,
  ],
};

const FAIL_PT: Partial<Record<ThemeKey, string[]>> = {
  pixel: [
    "GAME OVER, noob",
    "MISS! Insira uma meleca",
    "404: narina não achada",
    "Lag do dedo, errou",
    "WASTED, tonto",
    "Já vai dar rage quit?",
    "Hitbox errada, idiota",
    "Zero XP, banana",
    "Dedo em modo lag",
    "RESPAWN, mira melhor",
    "Skill issue, parça",
    "Sua mira crashou",
    "Errou, console desligado",
    "Combo quebrado, mané",
    "0 PTS, volta pro menu",
    "Bot no fácil, e errou",
    "Ping 999, dedo lerdo",
    "Insira ficha, otário",
    "Falha crítica pixelada",
    "Não terminou o tutorial",
    "Mirou em outra tela?",
    "Controle desligado, kkk",
    "Hardcore errou, casual",
    "Bug: narina.exe sumiu",
    "Reset, dedo de pau",
    ...SHARED_FAIL_PT,
  ],
  simpsons: [
    "DOU! Errou, banana",
    "Ai, caramba, errou!",
    "Coma minha meleca, errou",
    "Multiplique por zero",
    "Engula essa… e errou",
    "Homer te chama de burro",
    "Estúpido sexy fracasso",
    "Bart ri de você",
    "Nelson: HÁ-há! Errou",
    "Errou, seu Flanders",
    "Pior que o Ralph, bravo",
    "Pior erro do mundo",
    "Skinner: suspenso!",
    "Do lado, Homer gordo",
    "Zero rosquinha pra você",
    "Mo te põe pra fora",
    "Dou! Mão de manteiga",
    "Springfield te vaia",
    "Você fede, diz o nerd",
    "Fracasso pouco cromulento",
    "Krusty ri de você",
    "Usina em alerta: errou",
    "Mão de pé de Springfield",
    "Até o Ralph mira melhor",
    "Errou, seu burrão",
    ...SHARED_FAIL_PT,
  ],
  doodle: [
    "Nota zero, burro",
    "Duas horas de castigo",
    "Fora do tema, mão de pé",
    "No fundão, errou",
    "A fessora suspira, fraco",
    "Folha em branco, palhaço",
    "Vai pra diretoria!",
    "Reprovado de tanto cavar",
    "Anotação na agenda, errou",
    "Orelha de burro, banana",
    "Rabiscou do lado",
    "Copia 100 vezes: vou mirar",
    "Expulso da aula, pirralho",
    "Nota: 0/10, fraco",
    "O inspetor te pegou",
    "Dever não entregue",
    "Repetente do fundão",
    "Pego no flagra, vacilão",
    "Caneta seca, dedo seco",
    "Castigo no sábado, bravo",
    "Até o maternal mira melhor",
    "Seus pontos, apagados",
    "Turma toda de castigo",
    "Expulso por mira ruim",
    "Errou, pirralho de merda",
    ...SHARED_FAIL_PT,
  ],
  zombie: [
    "Errou, saco de larvas",
    "Até um morto mira melhor",
    "Do lado, carne fria",
    "Os dedos caíram, errou?",
    "Sem cérebro, né",
    "Errou, defunto velho",
    "Cérebro podre, fraco",
    "Mão de pé do além",
    "Já morto e ainda ruim",
    "O zumbi ri, errou",
    "Mira de defunto bêbado",
    "Gangrena até o dedo",
    "Errou, monte de podre",
    "Até carniçal mira melhor",
    "Do lado, carniça",
    "Dedo apodrecido, claro",
    "Errou, casca velha",
    "Cemitério da sua honra",
    "Larva no cérebro?",
    "Errou, saco de carne",
    "Fede a morte, errou",
    "Vá assombrar outro lugar",
    "Defunto desajeitado",
    "Podre até as unhas",
    "Game over… já tá morto",
    ...SHARED_FAIL_PT,
  ],
};

// ---------------------------------------------------------------------------

const SUCCESS: Record<Lang, Partial<Record<ThemeKey, string[]>>> = {
  fr: SUCCESS_FR,
  en: SUCCESS_EN,
  ru: SUCCESS_RU,
  es: SUCCESS_ES,
  pt: SUCCESS_PT,
};
const FAIL: Record<Lang, Partial<Record<ThemeKey, string[]>>> = {
  fr: FAIL_FR,
  en: FAIL_EN,
  ru: FAIL_RU,
  es: FAIL_ES,
  pt: FAIL_PT,
};

/** Messages de réussite du thème, dans la langue voulue (repli anglais). */
export function successMessages(lang: Lang, key: ThemeKey): string[] {
  return SUCCESS[lang][key] ?? SUCCESS.en[key] ?? [];
}

/** Messages d'échec du thème, dans la langue voulue (repli anglais). */
export function failMessages(lang: Lang, key: ThemeKey): string[] {
  return FAIL[lang][key] ?? FAIL.en[key] ?? [];
}
